/**
 * /secretariat/eleves — Fiches élèves (CRUD, suivi heures, formule).
 * Réutilise BoSecretariatElevesPage.
 */
import React from 'react';
import BoSecretariatElevesPage from '../bo/BoSecretariatElevesPage';

export default function SecretariatElevesPage() {
  return <BoSecretariatElevesPage embedded />;
}
